'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './service-requests-edit.routes';

export class ServiceRequestsEditComponent {

  constructor(IntegrationService, Auth, dialogs, $state, Config, Upload) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.Auth = Auth;
    this.dialogs = dialogs;
    this.$state = $state;
    this.integrationAvailable = true;
    this.IntegrationService = IntegrationService;
    this.Upload = Upload;
    this.mapPropertyBound = {};

    this.isLoading = true;
    this.files = [];
    this.acceptedFileTypes = 'image/*'; //'application/pdf,image/*';

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, "Service Request");

    this.configMS = Config.getPlatformConfig().getManagementSuiteIntegratonSettings();

    if (!this.configMS || !this.configMS.clientCode) {
      this.integrationAvailable = false;
      this.isLoading = false;
    }

    Auth.getCurrentUser(user => {
      let fullName = user.firstName;
      if (user.middleName)
        fullName += " " + user.middleName;
      fullName += " " + user.lastName;

      this.model = {
        requester: {
          email: user.email,
          fullName: fullName,
          firstName: user.firstName,
          middleName: user.middleName,
          lastName: user.lastName,
          communityCode: this.configMS.clientCode,
          webaccess: user.webaccessId
        },
        chat: [{
          note: "",
          firstName: user.firstName,
          middleName: user.middleName,
          lastName: user.lastName,
          meta: {
            webaccessUser: user.webaccessId
          }
        }]
      };
    });

    IntegrationService.test(result => {
      if (!result || !result.status || !result.status == 'successful') {
        this.integrationAvailable = false;
        this.isLoading = false;
      } else {

        IntegrationService.queryProperties(properties => {

          this.properties = properties.map(ppty => {
            ppty.name = ppty.propertyAddress + " / Lot# " + ppty.lotNo;
            return ppty;
          });

          //TODO: make service request for community possible; but multiple communities per webaccess possible
          /*
          this.properties.unshift({
            propertyId: null,
            name: "Common Area"
          });*/

        }, _=> {
        });

        IntegrationService.queryServiceRequestCodes(data => {
          this.codes = data.filter(code => code.published);
          this.codesEnum = this.codes.map(code => { return {code: code.code, name: code.name} });
          data.forEach(code => {
            this.mapPropertyBound[code.code] = code.propertyBound;
          })

          this.isLoading = false;
        });

      }
    })
  }

  removeFile(idx) {
   this.files.splice(idx,1);
  }

  selectFiles(files) {
    this.files = this.files.concat(files);
  }


  isNonViewableMime(mime) {
    return !(this.isHtmlMime(mime) || this.isImageMime(mime) || this.isPdfMime(mime));
  }

  isImageMime(mime) {
    return mime.startsWith('image/');
  }

  isPdfMime(mime) {
    return mime === 'application/pdf';
  }

  isHtmlMime(mime) {
    return mime == 'text/html';
  }

  isWordMime(mime) {
    return mime == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
      mime == 'application/msword';
  }

  isPowerPointMime(mime) {
    return mime == 'application/vnd.openxmlformats-officedocument.presentationml.presentation' ||
      mime == 'application/vnd.ms-powerpoint';
  }

  isExcelMime(mime) {
    return mime == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  }

  isOpenDocumentPresentation(mime) {
    return mime == 'application/vnd.oasis.opendocument.presentation';
  }

  isOpenDocumentText(mime) {
    return mime == 'application/vnd.oasis.opendocument.text';
  }

  isOpenDocumentSpreadsheet(mime) {
    return mime == 'application/vnd.oasis.opendocument.spreadsheet';
  }

  getIconByMime(mime) {
    if (this.isImageMime(mime))
      return "fa-file-image-o";
    else if (this.isPdfMime(mime))
      return "fa-file-pdf-o";
    else if (this.isHtmlMime(mime))
      return "fa-file-code-o";
    else if (this.isWordMime(mime))
      return "fa-file-word-o";
    else if (this.isOpenDocumentText(mime))
      return "fa-file-word-o";
    else if (this.isExcelMime(mime))
      return "fa-file-excel-o";
    else if (this.isOpenDocumentSpreadsheet(mime))
      return "fa-file-excel-o";
    else if (this.isPowerPointMime(mime))
      return "fa-file-powerpoint-o";
    else if (this.isOpenDocumentPresentation(mime))
      return "fa-file-powerpoint-o";
    else
      return "fa-file-o";
  }

  codeChanged () {
    let oCode = this.codes.find(code => code.code == this.model.code);

    if (!oCode)
      return;

    this.model.sequence = oCode.sequence;
    this.model.name = oCode.name;
    this.model.description = oCode.description;
    this.model.instructions = oCode.instructions;
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    var onSuccess = _ => {
      var dlg = this.dialogs.notify("Success", "The service request ticket has been created successfully");
      dlg.result.then(() => {
        that.$state.go("service-requests-list");
      });
    }

    var onError = err => {
      this.sendFailure = true;
      this.submitted = false;
    };

    if (form.$valid) {

      if (this.files && this.files.length) {

        var count = 0;
        var storageIds = [];

        this.files.forEach(file => {

          this.Upload.upload({
            url: this.configMS.baseUrlWeb + '/api/storage/web-portal',
            data: {
              name: file.name,
              file: file,
              storageStrategy: 'local',
              creationUser: this.Auth.getCurrentUserSync()._id,
              active: true
            }
          }).then(function (response) {
            storageIds.push(response.data);

            count++;

            if (count === that.files.length) {
              that.model.attachments = storageIds;
              that.IntegrationService.saveServiceRequest(that.model, onSuccess, onError);
            }

          }, function (response) {
            if (response.status > 0) {
              alert(response.status + ': ' + response.data);
            }
          });

        });

      } else {
        this.IntegrationService.saveServiceRequest(this.model, onSuccess, onError);
      }

    }
  }
}

export default angular.module('conduuApp.serviceRequests.edit', [uiRouter])
  .config(routes)
  .component('serviceRequestsEdit', {
    template: require('./service-requests-edit.html'),
    controller: ServiceRequestsEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/service-requests/edit/service-requests-edit.component.js